/**
 * Created by Administrador on 07/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {

        $stateProvider
            .state('flightAvailability', {
                parent: 'app',
                url: '/flightAvailability',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/report/levelOfSalesReservations/flightAvailability.html',
                        controller: 'flightAvailabilityCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['levelOfSalesReservations']);
                            }],
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabLevelOfSalesReservations('flightAvailability')
                            }]
                        }
                    }
                }
            })
    }
})();
